import { render, staticRenderFns } from "./Paginator.vue?vue&type=template&id=0e225b00&lang=pug&"
import script from "./Paginator.vue?vue&type=script&lang=ts&"
export * from "./Paginator.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports